const Websites = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5 12A2.5 2.5 0 0 1 6 9.5h9a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 18zm13 0h-12v6A1.5 1.5 0 0 0 6 19.5h9a1.5 1.5 0 0 0 1.5-1.5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9 3.5A2.5 2.5 0 0 0 6.5 6v1a.5.5 0 0 0 1 0V6h12v6c0 .365-.13.7-.348.96-.156.188-.245.442-.154.67.116.293.47.419.7.204.494-.457.802-1.11.802-1.834V6A2.5 2.5 0 0 0 18 3.5z"
    />
  </>
)
export default Websites
